import { render, staticRenderFns } from "./uiSwitch.vue?vue&type=template&id=fb9523e4&scoped=true"
import script from "./uiSwitch.vue?vue&type=script&lang=js"
export * from "./uiSwitch.vue?vue&type=script&lang=js"
import style0 from "./uiSwitch.vue?vue&type=style&index=0&id=fb9523e4&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fb9523e4",
  null
  
)

export default component.exports